import React, { createContext, useContext, useState, useEffect } from 'react';
import Cookies from 'js-cookie';

const AuthContext = createContext();

export const useAuth = () => {
  console.log('useAuth called');
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};

export const AuthProvider = ({ children }) => {
  console.log('AuthProvider initialized');
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  console.log('AuthProvider user state:', user);

 
  // Check authentication status on mount
  useEffect(() => {
    checkAuthStatus();
  }, []);

  const checkAuthStatus = async () => {
    console.log('checkAuthStatus called');
    setLoading(true);
    try {
      const response = await fetch(`${getBackendUrl()}/api/auth/me`, {
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
        },
      });

      console.log('checkAuthStatus response status:', response.status);
      if (response.ok) {
        const userData = await response.json();
        console.log('checkAuthStatus user data:', userData);
        setUser(userData);
      } else {
        console.log('Invalid session, response:', await response.text());
        setUser(null);
        // Cookies.remove('session_token', { path: '/' });
      }
    } catch (error) {
      console.error('Auth check failed:', error);
      setUser(null);
      // Cookies.remove('session_token', { path: '/' });
    } finally {
      setLoading(false);
    }
  };

  const getBackendUrl = () => {
    return process.env.REACT_APP_BACKEND_URL || 'http://localhost:8001';
  };

  const fetchSubscriptionData = async () => {
      try {
        const response = await fetch(`${getBackendUrl()}/api/subscription/current`, {
          credentials: 'include',
        });
        
        if (response.ok) {
          return  await response.json();
        }
        return false
      } catch (error) {
        console.error('Error fetching subscription data:', error);
        return false
      } 
  };

  const login = async (email, password) => {
    console.log('Starting login process...');
    console.log('Backend URL:', getBackendUrl());
    
    try {
      const requestData = { email, password };
      console.log('Login request data:', requestData);
      
      const response = await fetch(`${getBackendUrl()}/api/auth/login`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        credentials: 'include',
        body: JSON.stringify(requestData),
      });

      console.log('Login response status:', response.status);
      console.log('Login response ok:', response.ok);
      
      const data = await response.json();
      console.log('Login response data:', data);

      if (response.ok) {
        // Set session cookie with proper domain and path settings
        const cookieOptions = {
          expires: 7,
          sameSite: 'lax',
          secure: window.location.protocol === 'https:',
          path: '/'
        };
        
        Cookies.set('session_token', data.session_token, cookieOptions);
        setUser(data.user);
        console.log('✅ Login successful, user set:', data.user);
        console.log('✅ Session token set:', data.session_token);

        const subscription = await fetchSubscriptionData();


        return { success: true, subscription : subscription };
      } else {
        console.log('Login failed:', data.detail);
        return { success: false, error: data.detail };
      }
    } catch (error) {
      console.error('Login error:', error);
      return { success: false, error: 'Network error occurred' };
    }
  };

  const signup = async (email, password, name) => {
    console.log('Starting signup process...');
    console.log('Backend URL:', getBackendUrl());
    
    try {
      const requestData = { email, password, name };
      console.log('Signup request data:', requestData);
      
      const response = await fetch(`${getBackendUrl()}/api/auth/signup`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        credentials: 'include',
        body: JSON.stringify(requestData),
      });

      console.log('Signup response status:', response.status);
      console.log('Signup response ok:', response.ok);
      
      const data = await response.json();
      console.log('Signup response data:', data);

      if (response.ok) {
        // DO NOT auto-login after signup - user should login manually
        console.log('✅ Signup successful, user must login manually');
        return { success: true, user: data.user };
      } else {
        console.log('Signup failed:', data.detail);
        return { success: false, error: data.detail };
      }
    } catch (error) {
      console.error('Signup error:', error);
      return { success: false, error: 'Network error occurred' };
    }
  };

  const logout = async () => {
    console.log('Starting logout process...');
    try {
      await fetch(`${getBackendUrl()}/api/auth/logout`, {
        method: 'POST',
        credentials: 'include',
      });
      console.log('Logout request sent');
    } catch (error) {
      console.error('Logout error:', error);
    } finally {
      Cookies.remove('session_token', { path: '/' });
      setUser(null);
      console.log('User logged out, session cleared');
    }
  };

  const loginWithGoogle = () => {
    console.log('Redirecting to Google login...');
    window.location.href = `${getBackendUrl()}/api/auth/google`;
  };

  const value = {
    user,
    loading,
    login,
    signup,
    logout,
    loginWithGoogle,
    checkAuthStatus,
  };

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
};

export default AuthContext;